import React from 'react';
import { Sparkles } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="section-container relative" data-id="element-160">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 rounded-full blur-3xl -z-10" data-id="element-161"></div>

      <div className="text-container text-center" data-id="element-162">
        <div className="inline-flex items-center justify-center p-3 bg-gold/20 rounded-full mb-6 text-gold" data-id="element-163">
          <Sparkles className="w-8 h-8" data-id="element-164" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-165">
          El Protocolo del Interruptor de Cortisol
        </h2>
        <h3 className="text-xl md:text-2xl text-sage-dark font-medium mb-10 font-sans" data-id="element-166">
          La solución no es comer menos, es comer para calmar a tus hormonas.
        </h3>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft text-left border border-cream" data-id="element-167">
          <p className="text-lg md:text-xl leading-relaxed text-charcoal mb-6" data-id="element-168">
            Este método utiliza una combinación específica de alimentos
            antiinflamatorios y técnicas de respiración que le indican a tu
            sistema nervioso que el "peligro" ha pasado.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-charcoal font-medium bg-sage-light/30 p-6 rounded-xl border-l-4 border-sage-dark" data-id="element-169">
            Al apagar la señal del cortisol, tu cuerpo finalmente recibe el
            permiso hormonal para soltar el exceso de líquido y quemar la grasa
            depositada en la zona abdominal.
          </p>
        </div>
      </div>
    </section>;
}